import React from 'react'
import CustomNav from '../components/CustomNav'
import { Container, Row, Col, Card } from "react-bootstrap";
import about from "../images/about-banner.jpg"
import Footer from '../components/Footer';
import about2 from "../images/about2.webp"
import about3 from "../images/about3.webp"
import about4 from "../images/about4.webp"
import NewNav from '../components/NewNav';
import { motion } from 'framer-motion';

function About() {
  return (
    <>
      <NewNav />
      <div className='about-wrapper-page'>

        <motion.section className="showcase mb-5" initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}>
          <img src={about} alt="Picture" initial={{ scale: 1.1 }}
            animate={{ scale: 1 }}
            transition={{ duration: 1.5, ease: "easeOut" }} />
          <div className="overlay" initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.2, ease: "easeOut", delay: 0.5 }}>
            <h2>ABOUT US</h2>
          </div>
        </motion.section>

        <div className="container">
          <motion.div className="contentLeft" initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}>
            <div className="row">
              <motion.div className="imgWrapper" initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, }}
                viewport={{ once: true }}>
                <img src={about} alt="Image 1" />
              </motion.div>
              <div className="imgWrapper">
                <img src={about} alt="Image 2" />
              </div>
              <div className="imgWrapper">
                <img src={about} alt="Image 3" />
              </div>
              <div className="imgWrapper">
                <img src={about} alt="Image 4" />
              </div>
            </div>
          </motion.div>
          <motion.div className="contentRight" initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}>
            <div className="content">
              <motion.h4 initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: true }}>Welcome To</motion.h4>
              <motion.h2 initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.7 }}
                viewport={{ once: true }}>QH LIGHTING ABOUT US</ motion.h2>
              <motion.p initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.9 }}
                viewport={{ once: true }}>
                QHLighting is a leading LED lighting manufacturer with a rich history dating back to 1993. Our 70,000
                square meter factory in FoShan mainly provides customers with OEM LED Bulb, LED Panel, and LED Lighting
                Fixtures. At QHLighting, we are committed to providing high-quality products at an affordable cost,
                ensuring excellence at all times. The primary goal is to maintain the trust of our customers.
              </motion.p>
            </div>
          </motion.div>
        </div>


        <div className="container about-wrapper">

          <motion.div
            className="card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="imgBx">
              <img src={about} alt="SMT Workshop" />
            </div>
            <div className="content">
              <div>
                <h3>SMT Workshop</h3>
                <p className="content-p">
                  Our assembly workshop has 2 advanced automatic assembly lines with a daily production capacity of up to
                  50,000 bulbs and Tbulbs. To ensure the excellent quality of our products, we have set up a 15-minute
                  aging process.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="imgBx">
              <img src={about2} alt="Assembly Workshop" />
            </div>
            <div className="content">
              <div>
                <h3>Assembly Workshop</h3>
                <p className="content-p">
                  QHLighting's research and development team includes 5 experienced engineers. Specialist lighting test
                  equipment including EMC machines, oscilloscopes, and anti-surge machines are available in our laboratory.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="imgBx">
              <img src={about3} alt="R&D Center" />
            </div>
            <div className="content">
              <div>
                <h3>R&D Center</h3>
                <p className="content-p">
                  We will test and debug the photoelectric parameters of all products, including brightness, color
                  temperature, and color rendering index, to achieve accurate light performance.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="imgBx">
              <img src={about4} alt="Integrating Sphere Laboratory" />
            </div>
            <div className="content">
              <div>
                <h3>Integrating Sphere Laboratory</h3>
                <p className="content-p">
                  We will put the sample in an oven at 75-80 degrees for three months to test the working status of each
                  component to ensure that the product can operate normally even at high temperatures.
                </p>
              </div>
            </div>
          </motion.div>

        </div>

      </div>
      <Footer />

    </>
  )
}

export default About